(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mw-bundle-trust"] && !Shopify.designMode) return;
  try {
    const initializeModernWinkBundles = (scope = document) => {
    scope.querySelectorAll('[data-mw-bundle]:not([data-mw-ready])').forEach((bundle) => {
      bundle.dataset.mwReady = 'true';

      bundle.addEventListener('change', (event) => {
        const choice = event.target.closest('input[type="radio"]');
        if (!choice) return;

        const productDetails = bundle.closest('.product-details');
        const quantityInput = productDetails?.querySelector('input[name="quantity"]');
        if (!quantityInput) return;

        quantityInput.value = choice.value;
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('blur', { bubbles: true }));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeModernWinkBundles());
  } else {
    initializeModernWinkBundles();
  }

  document.addEventListener('shopify:section:load', (event) => initializeModernWinkBundles(event.target));
  } catch(e) { console.error(e); }
})();

})();
